import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ErrorDialogComponent } from "./error-dialog.component";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { MatLegacyListModule as MatListModule } from "@angular/material/legacy-list";

@NgModule({
	declarations: [ErrorDialogComponent],
	imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogModule, MatListModule]
})
export class ErrorDialogModule {}
